import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/pages',
      component: () => import('@/views/pages/Index'),
      children: [
        {
          name: 'Login',
          path: 'login',
          component: () => import('@/views/pages/Login'),
        },
        {
          name: 'Recover',
          path: 'Recover',
          component: () => import('@/views/pages/Recover'),
        },
      ],
    },
    {
      path: '/',
      component: () => import('@/views/dashboard/Index'),
      children: [
        // Dashboard
        {
          name: 'Dashboard',
          path: '',
          component: () => import('@/views/dashboard/Main'),
        },
        // Оформление ДТП
        {
          name: 'Оформление ДТП',
          path: '/accident/create',
          component: () => import('@/views/dashboard/Accident'),
          props: {
            create: true,
            short: false,
          },
        },
        {
          name: 'Оформление ДТП',
          path: '/accident/create/short',
          component: () => import('@/views/dashboard/AccidentOneScreen'),
          props: {
            create: true,
            short: false,
          },
        },
        /* {
          name: 'Оформление ДТП',
          path: '/accident/create/short',
          component: () => import('@/views/dashboard/Accident'),
          props: {
            create: true,
            short: true
          },
        }, */
        {
          name: 'Оформление договора',
          path: '/contract/create',
          component: () => import('@/views/dashboard/Contract'),
          props: {
            create: true,
          },
        },
        {
          name: 'Изменение договора',
          path: '/contract/change',
          component: () => import('@/views/dashboard/Contract'),
          props: {
            create: false,
            change: true,
            view: false,
          },
        },
        {
          name: 'Просмотр договора',
          path: '/contract/view',
          component: () => import('@/views/dashboard/Contract'),
          props: {
            create: false,
            change: false,
            view: true,
          },
        },
        {
          name: 'Создание полиса',
          path: '/insurance/create/',
          component: () => import('@/views/dashboard/InsuranceForm'),
          props: {
            create: true,
            change: false,
            view: false,
          },
        },
        {
          name: 'Изменение полиса',
          path: '/insurance/change/:id',
          component: () => import('@/views/dashboard/InsuranceForm'),
          props: {
            create: false,
            change: true,
            view: false,
          },
        },
        {
          name: 'Просмотр полиса',
          path: '/insurance/view/:id',
          component: () => import('@/views/dashboard/InsuranceForm'),
          props: {
            create: false,
            change: false,
            view: true,
          },
        },
        {
          name: 'Создание ТС',
          path: '/vehicle/create/',
          component: () => import('@/views/dashboard/VehicleForm'),
          props: {
            create: true,
            change: false,
            view: false,
          },
        },
        {
          name: 'Изменение ТС',
          path: '/vehicle/change/:id',
          component: () => import('@/views/dashboard/VehicleForm'),
          props: {
            create: false,
            change: true,
            view: false,
          },
        },
        {
          name: 'Просмотр ТС',
          path: '/vehicle/view/:id',
          component: () => import('@/views/dashboard/VehicleForm'),
          props: {
            create: false,
            change: false,
            view: true,
          },
        },
        {
          name: 'Оформление договора',
          path: '/contract/create/document',
          component: () => import('@/views/dashboard/Contract'),
          props: {
            create: true,
            kind: 1,
            change: false,
            view: false,
          },
        },
        {
          name: 'Оформление договора',
          path: '/contract/create/cession',
          component: () => import('@/views/dashboard/Contract'),
          props: {
            create: true,
            kind: 2,
            change: false,
            view: false,
          },
        },
        {
          name: 'Оформление договора',
          path: '/contract/create/:id',
          component: () => import('@/views/dashboard/Contract'),
          props: {
            create: true,
            from_contract: true,
            change: false,
            view: false,
          },
        },
        {
          name: 'Оформление договора',
          path: '/contract/create/:id/cession',
          component: () => import('@/views/dashboard/Contract'),
          props: {
            create: true,
            from_contract: true,
            kind: 2,
            change: false,
            view: false,
          },
        },
        {
          name: 'Оформление договора',
          path: '/contract/create/:id/legal',
          component: () => import('@/views/dashboard/Contract'),
          props: {
            create: true,
            from_contract: true,
            kind: 3,
            change: false,
            view: false,
          },
        },
        {
          name: 'Оформление договора',
          path: '/contract/create/:id/document',
          component: () => import('@/views/dashboard/Contract'),
          props: {
            create: true,
            from_contract: true,
            kind: 1,
            change: false,
            view: false,

          },
        },

        {
          name: 'Просмотр записи',
          path: '/accident/change/:id',
          component: () => import('@/views/dashboard/Accident-view'),
          props: {
            create: false,
            change: true,
            view: false,
          },
        },
        {
          name: 'Просмотр записи',
          path: '/accident/view/:id',
          component: () => import('@/views/dashboard/Accident-view'),
          props: {
            create: false,
            change: false,
            view: true,
          },
        },
        {
          name: 'Список ДТП',
          path: '/accident/list',
          component: () => import('@/views/dashboard/Accident-list'),
        },
        {
          name: 'События',
          path: '/event/list',
          component: () => import('@/views/dashboard/Calendar'),
        },
        {
          name: 'Список ДТП',
          path: '/accident/list/short',
          component: () => import('@/views/dashboard/AccidentShort-list'),
        },
        {
          name: 'Транзакции',
          path: '/transaction/list',
          component: () => import('@/views/dashboard/Transaction-list'),
        },
        {
          name: 'Транзакции',
          path: '/transaction/operations',
          component: () => import('@/views/dashboard/Operations-list'),
        },
        {
          name: 'Транзакция',
          path: '/transaction/view/:id',
          component: () => import('@/views/dashboard/components/Transaction-form'),
          props: {
            create: false,
            view: true,
          },
        },
        {
          name: 'Список договоров',
          path: '/contract/list',
          component: () => import('@/views/dashboard/Contract-list'),
        },
        {
          name: 'Список ТС',
          path: '/vehicle/list',
          component: () => import('@/views/dashboard/Vehicle-list'),
        },
        {
          name: 'Список ТС',
          path: '/driver/list',
          component: () => import('@/views/dashboard/Driver-list'),
        },
        {
          name: 'Список полисов',
          path: '/insurance/list',
          component: () => import('@/views/dashboard/Insurance-list'),
        },
        {
          name: 'Список полисов',
          path: '/insurance/list/manager',
          component: () => import('@/views/dashboard/Insurance-list-manager'),
        },
        {
          name: 'Список событий полисов',
          path: '/insurance/event/list',
          component: () => import('@/views/dashboard/Insurance-event-list'),
        },
        {
          name: 'Пользователи',
          path: '/users/list',
          component: () => import('@/views/dashboard/Users'),
        },

        {
          name: 'Профиль',
          path: '/profile',
          component: () => import('@/views/dashboard/UserProfile'),
        },
        {
          name: 'Справочники',
          path: '/dictionary/list',
          component: () => import('@/views/dashboard/Dictionary'),
        },
        {
          name: 'Отчет по договорам',
          path: '/reports/contracts',
          component: () => import('@/views/dashboard/reports/contracts'),
        },
        {
          name: 'Отчет по комиссарам',
          path: '/reports/comissars',
          component: () => import('@/views/dashboard/reports/comissars'),
        },
        {
          name: 'Отчет по страховым',
          path: '/reports/insurers',
          component: () => import('@/views/dashboard/reports/insurers'),
        },
        {
          name: 'Отчет по ТО',
          path: '/reports/to',
          component: () => import('@/views/dashboard/reports/to'),
        },
        {
          name: 'Отчет по расторженным договорам',
          path: '/reports/contract_cancel',
          component: () => import('@/views/dashboard/reports/contract_cancel'),
        },
        {
          name: 'Страхование',
          path: '/insurance/report',
          component: () => import('@/views/dashboard/reports/insurance'),
        },
        {
          name: 'Физические лица',
          path: '/clients/create',
          component: () => import('@/views/dashboard/Clients-page'),
          props: {
            create: true,
            change: false,
            view: false,
          },
        },
        {
          name: 'Физические лица',
          path: '/clients/view/:id',
          component: () => import('@/views/dashboard/Clients-page'),
          props: {
            create: false,
            change: false,
            view: true,
          },
        },
        {
          name: 'Физические лица',
          path: '/clients/change/:id',
          component: () => import('@/views/dashboard/Clients-page'),
          props: {
            create: false,
            change: true,
            view: false,
          },
        },
        {
          name: 'Список логов',
          path: '/log/list/',
          component: () => import('@/views/dashboard/Log-list'),
        },
        {
          name: 'Настройки',
          path: '/setting/list',
          component: () => import('@/views/dashboard/Setting-list'),
        },
        {
          name: 'Загрузка фото',
          path: '/photo/upload',
          component: () => import('@/views/dashboard/Upload-photo'),
        },
        {
          name: 'Список ссылок',
          path: '/photo/list/',
          component: () => import('@/views/dashboard/Link-list'),
        },
      ],
    },
    {
      path: '*',
      component: () => import('@/views/pages/Index'),
      children: [
        {
          name: '404 Error',
          path: '',
          component: () => import('@/views/pages/Error'),
        },
      ],
    },
  ],
})
